import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Table,
  Tag,
  TimePicker,
  Radio,
  Drawer,
  Skeleton,
} from "antd";
// import {useHistory} from "react-router";
import moment from "moment";
import {
  createDeNghiChamCongApi,
  listDeNghiChamCongApi,
  ListLoaiDeNghiApi,
  remainingLeaveDaysAPI,
} from "../../api/deNghiChamCong";
import {
  errorHandle,
  getFirstDayAndLastDayofMonth,
  validateMessages,
} from "../Function";
import CaLamViecApi from "../../api/getCaLamViec";
import { QuestionCircleOutlined } from "@ant-design/icons";

const { Search } = Input;

const renderStatusTag = (record) => {
  return (
    <Tag
      color={record.background}
      key={record.status}
      style={{
        color: record.color,
        fontWeight: "600",
        borderRadius: 10,
        border: `1px solid ${record.color}`,
      }}
    >
      {record.status}
    </Tag>
  );
};

function disabledDate(current, type) {
  if (type === "0") {
    return current && current > moment().endOf("day").add(-1, "days");
  }
  if (type === "2") {
    return current && current < moment().endOf("day").add(-1, "days");
  }
}

function disabledToDate(current, type, date_tungay) {
  if (current && current.month() < moment(date_tungay).month()) {
    return true;
  }
  if (type === "0") {
    if (current > moment(date_tungay)) {
      // console.log(current);

      return current && current > moment().endOf("day").add(-1, "days");
    }
    return true;
  }
  if (type === "2") { // Loại Nghỉ phép
    // Nếu ngày current trong lịch > từ ngày thì: nếu ngày current < ngày hiện tại trừ 1 thì True
    return current > moment(date_tungay)
      ? current && current < moment().endOf("day").add(-1, "days")
      : true;
  }
}
export const ModalTaoDeNghi = ({
  visible,
  onCancel,
  updateData,
  itemData = null,
}) => {
  const [form] = Form.useForm();
  const [lsLoaiDeNghi, setLsLoaiDeNghi] = useState([]);
  const [currentDeNghi, setCurrentDeNghi] = useState({});
  const [valueTypeCd, setValueTypeCd] = useState(null);
  const [lsCaLamViec, setLsCaLamViec] = useState([]);
  const [selectedCa, setSelectedCa] = useState("all");
  const [isTimeOnline, setIsTimeOnline] = useState(true);
  const [dataLeaveDays, setDataLeaveDays] = useState([]);

  const [loadingLeave, setLoadingLeave] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  const onOK = () => {
    form.submit();
  };
  const onCloseModal = () => {
    form.resetFields();
    setCurrentDeNghi([]);
    onCancel();
  };
  const onChangeTypeCD = (e) => {
    setValueTypeCd(e.target.value);
    const dataCheDo = currentDeNghi.thoigianChedo.filter(
      (item) => item.id.toString() === e.target.value.toString()
    );
    if (dataCheDo && dataCheDo.length > 0) {
      const data = dataCheDo[0];
      form.setFieldsValue({
        // giovao: moment((moment(new Date()).format("YYYYMMDD") + data.gioVao),"YYYYMMDDHH:mm:ss"),
        // giora: moment((moment(new Date()).format("YYYYMMDD") + data.gioRa),"YYYYMMDDHH:mm:ss"),
        giovao: data.gioVao.toString().substr(0, 5),
        giora: data.gioRa.toString().substr(0, 5),
      });
    }
    form.setFieldsValue({ typecd: e.target.value });
  };

  const fetchCaLamViec = () => {
    CaLamViecApi({ idTeam: JSON.stringify([]) }).then((res) => {
      setLsCaLamViec(res.data.filter((i) => i.isActive === true));
    });
  };

  useEffect(() => {
    fetchListLoaiDeNghi();
    fetchCaLamViec();
    // console.log(dateNow);
  }, [visible]);

  const onFinish = (values) => {
    let gioRa = "";
    let gioVao = "";
    // if (values.giora){
    //     gioRa = typeof values.giora === "string" ? values.giora : moment(new Date(values.giora)).format("HH:mm")
    // }
    // if (values.giovao){
    //     gioVao = typeof values.giovao === "string" ? values.giovao : moment(new Date(values.giovao)).format("HH:mm")
    // }
    if (form.getFieldValue("giora")) {
      gioRa =
        typeof form.getFieldValue("giora") === "string"
          ? form.getFieldValue("giora")
          : moment(new Date(form.getFieldValue("giora"))).format("HH:mm");
    }
    if (form.getFieldValue("giovao")) {
      gioVao =
        typeof form.getFieldValue("giovao") === "string"
          ? form.getFieldValue("giovao")
          : moment(new Date(form.getFieldValue("giovao"))).format("HH:mm");
    }
    let obj = {};
    obj.tuNgay = values.tungay
      ? moment(new Date(values.tungay)).format("YYYY-MM-DD")
      : undefined;
    obj.denNgay = values.denngay
      ? moment(new Date(values.denngay)).format("YYYY-MM-DD")
      : moment(values.tungay).format("YYYY-MM-DD");
    obj.gioVao = gioVao;
    obj.gioRa = gioRa;
    obj.gioGiailao = values.giogiailao || "0";
    obj.idLoai = values.loaidenghi;
    obj.idChitietLoai = values.loaidenghichitiet || "";
    obj.lydoDenghi = values.lydo || "";
    obj.idCD = valueTypeCd || "";

    createDeNghiChamCongApi(obj)
      .then((r) => {
        updateData();
        onCloseModal();
        setLsLoaiDeNghi([]);
        setCurrentDeNghi({});
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onFinishFailed = (values) => {
    console.log("Received values of form:", values);
  };

  const fetchListLoaiDeNghi = () => {
    ListLoaiDeNghiApi().then((res) => {
      setLsLoaiDeNghi(res.data);
    });
  };

  const onChangeCa = (value) => {
    // 140825 dành cho chấm công online
    setSelectedCa(value);

    if (value == "CaSang") {
      var dictCaSang = lsCaLamViec.filter((item) => item.tenCa == "Ca Sáng")[0];
      var dictCaChieu = dictCaSang;
    }
    if (value == "CaChieu") {
      var dictCaChieu = lsCaLamViec.filter(
        (item) => item.tenCa == "Ca Chiều"
      )[0];
      var dictCaSang = dictCaChieu;
    }
    if (value == "all") {
      var dictCaSang = lsCaLamViec.filter((item) => item.tenCa == "Ca Sáng")[0];
      var dictCaChieu = lsCaLamViec.filter(
        (item) => item.tenCa == "Ca Chiều"
      )[0];
    }
    form.setFieldsValue({
      giovao: moment(dictCaSang.gioVao, "h:mm:ss"),
      giora: moment(dictCaChieu.gioRa, "h:mm:ss"),
    });
    // }
  };

  const onChangeLoaiDeNghi = (value) => {
    if (value) {
      form.resetFields();
      const currentLoaiDeNghi = lsLoaiDeNghi.filter(
        (item) => item.id === value
      );
      form.setFieldsValue({
        loaidenghi: currentLoaiDeNghi[0].id,
        giovao: "",
        giora: "",
      });
      if (currentLoaiDeNghi[0].maLoaiNgay === "1") {
        // 1: Tương lai
        form.setFieldsValue({ tungay: moment(new Date()) });
      }

      // Chấm công online | statusCC = 0 là tạo giờ ra, statusCC = 1 là tạo giờ vào
      setSelectedCa("all");
      if (
        currentLoaiDeNghi[0] &&
        currentLoaiDeNghi[0].gioVao &&
        [0, 1].includes(currentLoaiDeNghi[0].statusCC)
      ) {
        form.setFieldsValue({
          giovao:
            lsCaLamViec &&
            moment(
              lsCaLamViec.filter((item) => item.tenCa == "Ca Sáng")[0].gioVao,
              "h:mm:ss"
            ), // 250423 moment(new Date())
        });
      }
      if (
        currentLoaiDeNghi[0] &&
        currentLoaiDeNghi[0].gioRa &&
        [0, 1].includes(currentLoaiDeNghi[0].statusCC)
      ) {
        form.setFieldsValue({
          giora:
            lsCaLamViec &&
            moment(
              lsCaLamViec.filter((item) => item.tenCa == "Ca Chiều")[0].gioRa,
              "h:mm:ss"
            ), // 250423 moment(new Date())
        });
      }

      if (currentLoaiDeNghi[0] && currentLoaiDeNghi[0].thoigianChedo) {
        const objChedo = currentLoaiDeNghi[0].thoigianChedo.filter(
          (item) => item.isDefault === true
        );
        if (objChedo && objChedo.length > 0) {
          setValueTypeCd(objChedo[0].id);
          form.setFieldsValue({
            typecd: objChedo[0].id,
            giovao: objChedo[0].gioVao.toString().substr(0, 5),
            giora: objChedo[0].gioRa.toString().substr(0, 5),
          });
        }
      }

      if (
        currentLoaiDeNghi[0].tuNgay &&
        currentLoaiDeNghi[0].denNgay &&
        itemData != null
      ) {
        form.setFieldsValue({
          tungay: moment(itemData.ngay, "YYYY-MM-DD"),
          denngay: moment(itemData.ngay, "YYYY-MM-DD"),
        });
      }

      form.setFieldsValue({ giogiailao: "0" });
      setCurrentDeNghi(currentLoaiDeNghi[0]);

      // Loại đề nghị Nghỉ phép | Tính phép còn lại
      if (value === 7) {
        setLoadingLeave(true);
        remainingLeaveDaysAPI()
          .then((res) => {
            setLoadingLeave(false);
            form.setFieldsValue({
              leavedays: res.data.remaining_leave_day_conv,
            });
            setDataLeaveDays(res.data);
          })
          .catch((err) => {
            setLoadingLeave(false);
            errorHandle(err);
          });
      }
    } else {
      setCurrentDeNghi([]);
    }
  };

  const getDisableHourTimeOut = () => {
    const timeStart = form.getFieldValue("giovao");
    const timeIn = timeStart ? timeStart._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourTimeIn = () => {
    const time = form.getFieldValue("giora");
    const timeIn = time ? time._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  return (
    <Modal
      open={visible}
      onCancel={onCloseModal}
      onOk={onOK}
      // title={"Tạo đề nghị chấm công"}
      maskClosable={false} // Tắt click ra ngoài để đóng
      className={"site-drawer-render-in-current-wrapper"}
      bodyStyle={{ minHeight: "450px" }}
      title={
        <div
          style={{
            // display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Tạo đề nghị chấm công</span>
          <Button
            type="link"
            icon={<QuestionCircleOutlined />}
            onClick={() => showDrawer()}
            style={{
              float: "right",
              marginRight: "25px",
              paddingBottom: "20px",
            }}
          ></Button>
        </div>
      }
      footer={currentDeNghi && currentDeNghi.statusCC === 2 ? false : true}
    >
      <div className={"row"}>
        <Form
          form={form}
          name={"form-create-de-nghi"}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout={"vertical"}
          validateMessages={validateMessages}
        >
          <Form.Item
            name={"loaidenghi"}
            label={"Loại đề nghị"}
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Chọn loại đề nghị"
              onChange={onChangeLoaiDeNghi}
            >
              {lsLoaiDeNghi.map((item, index) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.tenLoaiDenghi}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {currentDeNghi && currentDeNghi.id === 7 && dataLeaveDays && (
            <div className={"row"}>
              <div className={"col-12"}>
                <Form.Item name="leavedays" label={"Số phép dự kiến còn lại"}>
                  {loadingLeave ? (
                    <Skeleton.Input active size="small" block />
                  ) : (
                    <Input disabled />
                  )}
                </Form.Item>
              </div>
            </div>
          )}
          {currentDeNghi.data && currentDeNghi.data.length > 0 && (
            <Form.Item
              name={"loaidenghichitiet"}
              label={"Chi tiết"}
              rules={[{ required: true }]}
            >
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="Chọn loại đề nghị chi tiết"
              >
                {currentDeNghi.data.map((item, index) => (
                  <Select.Option key={index + item.id} value={item.id}>
                    {item.tenChitiet}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {currentDeNghi.tuNgay && !currentDeNghi.denNgay && (
            <Form.Item
              name={"tungay"}
              label={"Ngày"}
              rules={[{ required: true }]}
            >
              {currentDeNghi.maLoaiNgay === "1" ? (
                <DatePicker disabled format={"DD/MM/YYYY"} />
              ) : (
                <DatePicker
                  disabledDate={(current) =>
                    disabledDate(current, currentDeNghi.maLoaiNgay)
                  }
                />
              )}
            </Form.Item>
          )}
          {currentDeNghi.tuNgay && currentDeNghi.denNgay && (
            <div className={"row"}>
              <div className={"col-6"}>
                <Form.Item
                  name={"tungay"}
                  label={"Từ ngày"}
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    disabledDate={(current) =>
                      disabledDate(current, currentDeNghi.maLoaiNgay)
                    }
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </div>
              <div className={"col-6"}>
                <Form.Item
                  name={"denngay"}
                  label={"Đến ngày"}
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    disabledDate={(current) =>
                      disabledToDate(
                        current,
                        currentDeNghi.maLoaiNgay,
                        form.getFieldValue("tungay")
                      )
                    }
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </div>
            </div>
          )}

          {Object.entries(currentDeNghi).length > 0 && (
            <>
              <div className={"row"}>
                {currentDeNghi.isRegime && (
                  <div className={"col-12"}>
                    <Form.Item
                      name={"typecd"}
                      label={"Chọn khung giờ chế độ"}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group
                        value={valueTypeCd}
                        onChange={onChangeTypeCD}
                      >
                        {currentDeNghi.thoigianChedo.map((item, index) => (
                          <Radio value={item.id}>{item.ten}</Radio>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                  </div>
                )}
              </div>

              <div className={"row"}>
                {currentDeNghi &&
                  currentDeNghi.statusCC != "2" &&
                  currentDeNghi.maLoai == "chamcongonline" && ( // Chọn ca lam việc
                    <div className={"col-6"}>
                      <Form.Item name={"calamviec"} label={"Ca làm việc"}>
                        <Select
                          // allowClear
                          style={{ width: "100%" }}
                          // placeholder=""
                          onChange={onChangeCa}
                          defaultValue="all"
                          value={selectedCa}
                        >
                          {/* <Select.Option key={'optional'} value={'optional'}>-----</Select.Option> */}
                          <Select.Option key={"all"} value={"all"}>
                            Cả ngày
                          </Select.Option>
                          <Select.Option key={"CaSang"} value={"CaSang"}>
                            Ca sáng
                          </Select.Option>
                          <Select.Option key={"CaChieu"} value={"CaChieu"}>
                            Ca chiều
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  )}

                {currentDeNghi &&
                  currentDeNghi.gioVao &&
                  [null, 0, 1].includes(currentDeNghi.statusCC) && ( //[null, 0] nếu cc online chỉ tạo giờ vào
                    <div
                      className={
                        currentDeNghi.maLoai == "chamcongonline"
                          ? "col-3"
                          : "col-6"
                      }
                    >
                      <Form.Item
                        name={"giovao"}
                        label={"Giờ vào"}
                        rules={[{ required: true }]}
                      >
                        <TimePicker
                          // disabled={
                          //   currentDeNghi.maLoai == "chamcongonline"
                          //     ? isTimeOnline
                          //     : !currentDeNghi.editGioVao
                          // }
                          format={"HH:mm"}
                          onSelect={(value) =>
                            form.setFieldsValue({ giovao: value })
                          }
                          disabledHours={getDisableHourTimeIn}
                        />
                      </Form.Item>
                    </div>
                  )}
                {currentDeNghi &&
                  currentDeNghi.gioRa &&
                  [null, 0, 1].includes(currentDeNghi.statusCC) && ( // [null, 1] nếu cc online chỉ tạo giờ ra
                    <div
                      className={
                        currentDeNghi.maLoai == "chamcongonline"
                          ? "col-3"
                          : "col-6"
                      }
                    >
                      <Form.Item
                        name={"giora"}
                        label={"Giờ ra"}
                        rules={[{ required: true }]}
                      >
                        <TimePicker
                          // disabled={
                          //   currentDeNghi.maLoai == "chamcongonline"
                          //     ? isTimeOnline
                          //     : !currentDeNghi.editGioRa
                          // }
                          format={"HH:mm"}
                          onSelect={(value) =>
                            form.setFieldsValue({ giora: value })
                          }
                          disabledHours={getDisableHourTimeOut}
                        />
                      </Form.Item>
                    </div>
                  )}
                {currentDeNghi &&
                  currentDeNghi.gioGiailao &&
                  currentDeNghi.isOT && (
                    <div className={"col-6"}>
                      <Form.Item
                        name={"giogiailao"}
                        label={"Giờ giải lao"}
                        rules={[{ required: true }]}
                      >
                        <InputNumber min={0}></InputNumber>
                      </Form.Item>
                    </div>
                  )}
                {currentDeNghi && currentDeNghi.statusCC === 2 && (
                  <h3 className={"text text-danger text-center"}>
                    Bạn đã hoàn thành chấm công hôm nay
                  </h3>
                )}
              </div>
              {currentDeNghi && currentDeNghi.statusCC !== 2 && (
                <div className={"row"}>
                  <div className={"col-12"}>
                    <Form.Item name={"lydo"} label={"Lý do đề nghị"}>
                      <Input></Input>
                    </Form.Item>
                  </div>
                </div>
              )}
            </>
          )}
        </Form>
        <div
          className={"row col-12 justify-content-center"}
          style={{
            position: "absolute",
            bottom: "16px",
            left: 0,
            width: "100%",
          }}
        >
          {currentDeNghi && currentDeNghi.statusCC !== 2 && (
            <div className={"col-3"}>
              <Button
                htmlType={"button"}
                type={"primary"}
                onClick={() => onOK()}
              >
                Xác nhận
              </Button>
            </div>
          )}
          <div className={"col-3 text-center"}>
            <Button
              htmlType={"button"}
              type={"primary"}
              danger
              onClick={() => onCancel()}
            >
              Thoát
            </Button>
          </div>
        </div>
      </div>
      <Drawer
        title="Hướng dẫn sử dụng"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={400}
        keyboard
        getContainer={false}
      >
        <p>
          <strong>1. Chế độ bảo hiểm và Chế độ khác</strong>
        </p>
        <ul>
          <li>
            Bảo hiểm không tính vào ngày chủ nhật, nên nhân viên không tạo đề
            nghị vào ngày này.
          </li>
        </ul>
        <p>
          <strong>2. Nghỉ phép</strong>
        </p>
        <ul>
          <li>
            Số phép dự kiến còn lại = <i>[Số phép còn lại của tháng trước]</i> -{" "}
            <i>[Số phép các đề nghị đã duyệt]</i>
          </li>
          <li>
            Nếu tổng số ngày đăng ký{" "}
            <span style={{ color: "red" }}>&lt;=3</span> ngày, nhân viên vui
            lòng thực hiện đăng ký{" "}
            <span style={{ color: "red" }}>trước 18h ngày trước</span> đó. Vd:
            Đăng ký nghỉ phép từ ngày 01-03/8 thì hạn đăng ký trước 18h ngày
            31/07.
          </li>
          <li>
            Nếu tổng số ngày đăng ký <span style={{ color: "red" }}>&gt;3</span>{" "}
            ngày, nhân viên vui lòng thực hiện đăng ký trước{" "}
            <span style={{ color: "red" }}>18h của 3 ngày trước</span> đó. Vd:
            Đăng ký nghỉ phép từ ngày 01-05/08 thì hạn đăng ký trước 18h ngày
            29/07.
          </li>
          <li>
            <span style={{ color: "red" }}>Bộ phận HR sẽ duyệt phép</span> khi
            tổng số ngày đăng ký <span style={{ color: "red" }}>&gt;5</span>{" "}
            ngày và quản lý đã duyệt phép.
          </li>
          <li>
            Nếu số phép dự kiến còn lại là{" "}
            <span style={{ color: "red" }}>0</span>, nhân viên tiếp tục đề nghị
            nghỉ phép, thì số phép thực tế còn lại sẽ{" "}
            <span style={{ color: "red" }}>âm phép</span>.
          </li>
        </ul>
      </Drawer>
    </Modal>
  );
};

export const DeNghiChamCong = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({ pageSize: defaultPageSize, current: 1 });
  const [data, setData] = useState([]);
  const [current, setCurrent] = useState(new Date());
  const [firstDay, setFirstDay] = useState(
    getFirstDayAndLastDayofMonth(new Date())[0]
  );
  const [lastDay, setLastDay] = useState(
    getFirstDayAndLastDayofMonth(new Date())[1]
  );
  const [loading, setLoading] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [search, setSearch] = useState(null);

  const fetchListDeNghi = (params = {}) => {
    listDeNghiChamCongApi({ ...params }).then((r) => {
      setData(r.data);
    });
  };

  // useEffect(() => {
  //     fetchListDeNghi({
  //         tuNgay:firstDay,
  //         denNgay:lastDay,
  //         page_size: pager.pageSize,
  //         page: 1
  //     }
  //     );
  // }, [current])

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchListDeNghi({
      page_size: pagination.pageSize,
      page: pagination.current,
      search,
      tuNgay: firstDay,
      denNgay: lastDay,
    });
  };

  useEffect(() => {
    if (current) {
      const id = setInterval(() => {
        fetchListDeNghi({
          tuNgay: firstDay,
          denNgay: lastDay,
          search,
          page_size: pager.pageSize,
          page: 1,
        });
        setPager({ pageSize: defaultPageSize, current: 1 });
        clearInterval(id);
      }, 500);
      return () => clearInterval(id);
    }
  }, [current, search]);

  const onChangeMonth = (date) => {
    const lsDay = getFirstDayAndLastDayofMonth(date._d);
    setFirstDay(lsDay[0]);
    setLastDay(lsDay[1]);
    setCurrent(date._d);
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Loại đề nghị",
      dataIndex: "tenloaiDenghi",
      key: "tenloaiDenghi",
      filterKey: "tenloaiDenghi",
      className: "highlight",
      render: (text, record) => (
        <span>
          {record.chitietLoaiDenghi
            ? record.tenloaiDenghi + " - " + record.chitietLoaiDenghi
            : record.tenloaiDenghi}
        </span>
      ),
      type: "text",
      canSearch: true,
    },
    {
      title: "Ngày đề nghị",
      dataIndex: "created",
      key: "created",
      filterKey: "created",
      className: "highlight",
      type: "text",
      render: (text) => moment(new Date(text)).format("DD/MM/YYYY"),
      canSearch: true,
    },
    {
      title: "Từ ngày",
      dataIndex: "tuNgay",
      key: "tuNgay",
      className: "highlight",
      filterKey: "tuNgay",
      render: (text, record) => moment(text).format("L"),
      type: "date",
      canSearch: true,
    },
    {
      title: "Đến ngày",
      dataIndex: "denNgay",
      key: "denNgay",
      className: "highlight",
      filterKey: "denNgay",
      render: (text, record) => (text ? moment(text).format("L") : ""),
      type: "date",
      canSearch: true,
    },
    {
      title: "Giờ vào",
      dataIndex: "gioVao",
      key: "gioVao",
      className: "highlight",
      filterKey: "gioVao",
      render: (text, record) => text && text.toString().substr(0, 5),
      type: "text",
      canSearch: true,
    },
    {
      title: "Giờ ra",
      dataIndex: "gioRa",
      key: "gioRa",
      className: "highlight",
      filterKey: "gioRa",
      render: (text, record) => text && text.toString().substr(0, 5),
      type: "date",
      canSearch: true,
    },
    {
      title: "Lý do đề nghị",
      dataIndex: "lydoDenghi",
      key: "lydoDenghi",
      className: "highlight",
      filterKey: "lydoDenghi",
      type: "text",
      canSearch: true,
    },
    {
      title: "Lý do không duyệt",
      dataIndex: "lydoKhongduyet",
      key: "lydoKhongduyet",
      className: "highlight",
      filterKey: "lydoKhongduyet",
      type: "text",
      canSearch: true,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      className: "highlight",
      filterKey: "status",
      render: (text, record) => renderStatusTag(record),
      type: "text",
      canSearch: true,
    },
  ];

  const updateData = () => {
    fetchListDeNghi({
      tuNgay: firstDay,
      denNgay: lastDay,
      page_size: pager.pageSize,
      page: pager.current,
    });
  };

  const onSearch = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Đề nghị chấm công</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Cá nhân</a>
                </li>
                <li className="breadcrumb-item active">Đề nghị chấm công</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-2">
        <div
          className={
            "col-12 d-sm-flex align-items-center justify-content-between"
          }
        >
          <div className={"col"}>
            <DatePicker
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeMonth}
              picker="month"
              defaultValue={moment(current)}
              format={"MM/YYYY"}
              allowClear={false}
            />
          </div>
          <div className={"col"}>
            <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
              <Col>
                <Button type={"primary"} onClick={() => setIsShowModal(true)}>
                  Tạo đề nghị
                </Button>
              </Col>
              <Col>
                <Search
                  placeholder="Nhập từ khóa tìm kiếm"
                  size="normal"
                  onChange={onSearch}
                  loading={false}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data.results}
          columns={columns}
          loading={loading}
          bordered={true}
          size={"small"}
          rowKey="id"
          onChange={handleChange}
          className={"custom-table-hover"}
          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: data.count,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
      </div>
      <ModalTaoDeNghi
        visible={isShowModal}
        onCancel={() => setIsShowModal(false)}
        updateData={updateData}
      />
    </>
  );
};
